"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxRulesService = void 0;
const TaxRulesServiceStub_1 = require("./TaxRulesServiceStub");
const TaxRulesServiceLive_1 = require("./TaxRulesServiceLive");
class TaxRulesService {
    static create(stub) {
        if (stub) {
            return new TaxRulesServiceStub_1.TaxRulesServiceStub();
        }
        return new TaxRulesServiceLive_1.TaxRulesServiceLive();
    }
}
exports.TaxRulesService = TaxRulesService;
//# sourceMappingURL=TaxRulesService.js.map